import * as React from 'react'
import { cn } from '@/lib/utils'

const badgeVariants = {
  default: 'tw:bg-primary tw:text-primary-foreground tw:shadow tw:hover:bg-primary/80',
  secondary: 'tw:bg-secondary tw:text-secondary-foreground tw:hover:bg-secondary/80',
  destructive: 'tw:bg-destructive tw:text-destructive-foreground tw:shadow tw:hover:bg-destructive/80',
  outline: 'tw:text-foreground tw:border tw:border-input tw:bg-background tw:shadow-sm',
  // Custom variant for campaign objectives
  campaign: 'tw:bg-[#334155] tw:text-[#94A3B8] tw:border-0 tw:shadow-none',
}

function Badge({ className, variant = 'default', ...props }) {
  return (
    <div
      className={cn(
        'tw:inline-flex tw:items-center tw:rounded-md tw:px-2.5 tw:py-0.5 tw:text-xs tw:font-medium tw:transition-colors tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2',
        badgeVariants[variant],
        className
      )}
      {...props}
    />
  )
}

export { Badge, badgeVariants }